var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1FactoryTour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 63.58V70H45v-6.42A4.53 4.53 0 0149.44 59h15.09A4.53 4.53 0 0169 63.58zM69 5v21H38V12.61L54 5v7.59L69 5zM50 17h-7v3h7v-3zm14 0h-7v3h7v-3zm-3.88 38.93a5 5 0 10-6.204-7.843 5 5 0 006.204 7.843zm-31.64-29A13.22 13.22 0 0017.85 22H7v21h16V28.86L37 44.6a2.65 2.65 0 003.73.23 3 3 0 00.64-.82 2.73 2.73 0 00-.45-3.08l-12.44-14zM35.53 59H20.44A4.53 4.53 0 0016 63.58V70h24v-6.42A4.53 4.53 0 0035.53 59zm-4.41-3.07a5 5 0 10-6.204-7.843 5 5 0 006.204 7.843zM18 18.19a6 6 0 10-7.443-9.412A6 6 0 0018 18.19z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Factory_tour.f1b09f6a.svg";
export { SvgF1FactoryTour as ReactComponent };